import * as cpfCnpjValidator from 'cpf-cnpj-validator';

const onlyNumbers = /\d+/g;

export function cpf(value) {
  return value && cpfCnpjValidator.cpf.isValid(value) ? true : false;
}

export function cnpj(value) {
  return value && cpfCnpjValidator.cnpj.isValid(value) ? true : false;
}

export function cep(value) {
  if (value == undefined) return false;

  var number = (value.match(onlyNumbers) || []).join('');
  return (number.length == 8);
}

export function phone(value) {
  if (value == undefined) return false;
  var number = (value.match(/\d+/g) || []).join('');
  if (number.length < 2) return false;
  var prefix = number.substring(0, 2);
  return prefixes.indexOf(prefix) != -1;
}

const prefixes = [
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '21',
    '22',
    '24',
    '27',
    '28',
    '31',
    '32',
    '33',
    '34',
    '35',
    '37',
    '38',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    '49',
    '51',
    '53',
    '54',
    '55',
    '61',
    '62',
    '63',
    '64',
    '65',
    '66',
    '67',
    '68',
    '69',
    '71',
    '73',
    '74',
    '75',
    '77',
    '79',
    '81',
    '82',
    '83',
    '84',
    '85',
    '86',
    '87',
    '88',
    '89',
    '91',
    '92',
    '93',
    '94',
    '95',
    '96',
    '97',
    '98',
    '99'
  ];

  export function toNumberSafe(value) {
    if (value === null || value === undefined || value === '') {
      return 0;
    }
    const num = Number(value);
    return isNaN(num) ? 0 : num;
  }
  
  export function replaceKeywords(content, replacements) {
    let result = content;
    for (const [key, value] of Object.entries(replacements)) {
      result = result.replace(new RegExp(key, 'g'), value);
    }
    return result;
  }